module.exports = __webpack_public_path__ + "static/media/country_ls.4f159c36.webp";